import React, { Component } from 'react'
import { CustomInput, Label, Input, FormGroup, FormFeedback, Form } from 'reactstrap';
import EirButton from '../eir-button/EirButton';
import EirRecaptcha from '../eir-recaptcha/EirRecaptcha';

export class EirOnlineAuthorizedUserForm extends Component {
    constructor(props) {
        super(props);
        this.state = {

            isDeclationAccept: true,
            isAgeDeclaration: true,
            sending: false,
            countyList: [],
            response: null,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillMount = () => {
        fetch('/json/counties.txt')
            .then(res => res.json())
            .then(data => this.setState({ countyList: data }))
    }
    renderContent = (content) => {

        return { __html: content };

    }
    emailScript = (e) => {
        var email_val = $("#Customers_Email_Address").val();
        $("#EMAIL_FROM_ADDRESS_OVERRIDE").val(email_val);
    }
    declarationAge = () => {

        this.setState({
            isAgeDeclaration: !this.state.isAgeDeclaration
        })

    }
    declarationAccept = () => {
        this.setState({
            isDeclationAccept: !this.state.isDeclationAccept

        })


    }

    async handleSubmit(event) {
        let form = event.target;
        event.preventDefault();
        event.stopPropagation();
        form = $("form")[0];
        if (form.checkValidity() != false) {
            this.setState({
                sending: true
            });

            let response = await fetch(this.props.action,
                {
                    method: form.method,
                    body: new FormData($("form")[0])
                }
            );

            this.setState({
                response: (response.ok ? await response.json() : false),
                sending: false
            });
            if ((this.state.response != null && this.state.response.result.status == 'success') || (this.state.response != null && (this.state.response.result.status == 'failure' || this.state.response == false))) {
                let scrollStep = -window.pageYOffset / (1000 / 15);
                let scrollInterval = setInterval(function () {
                    if (window.pageYOffset != 0) {
                        window.scrollBy(0, scrollStep);

                    } else clearInterval(scrollInterval);
                }, 15);
            }
        }
        form.classList.add('was-validated');

        if ($(".was-validated .form-control:invalid")[0] != undefined) {
            $(".was-validated .form-control:invalid")[0].focus();
        }
    }
    render() {

        const CList = this.state.countyList.counties;

        return (
            <div className="bereavement-forms">
                <div className="mb-5 mt-5 container d-flex flex-column align-items-center justify-content-center">
                    <h2>Authorised User Form</h2>
                    <p>Completing the below form will allow you to add an authorised user to your account allowing the nominated person to discuss elements of your account on your behalf. The information you provide is solely used for the purpose of identifying you as authorised to make this request to add an authorised user and to confirm to you<br /> that this has been completed.</p>
                    <p>Your authorised user will have the ability to discuss billing, payments and general management for your account. The authorised user will not have the ability to make contractual or overall service changes to your plan or amend financial information.</p>
                    <p>This data provided will not be used for marketing or other purposes unless you have previously opted in for such processing.</p>
                    <p>For further information click here to see our <a aria-label="Frequently asked questions" target="_blank" href="https://eir.ie/support/billing/authorised-user/">Frequently asked questions.</a> </p>
                    <p>Authorised users must be over the age of 18.</p>

                </div>
                {(this.state.response == null && !this.state.sending) && (

                    <Form method="post" action={this.props.action} noValidate={false} className="needs-validation d-flex flex-column align-items-center justify-content-center" id="bereavement-form" onSubmit={this.handleSubmit} >
                        <Input type="hidden" value={this.props.email} id="Email_To_Address" name="Email_To_Address" />
                        <Input type="hidden" value="Authorised User Form" id="Email_Subject" name="Email_Subject" />
                        <Input type="hidden" value={this.props.formName} id="Form_Name" name="Form_Name" />
                        <Input type="hidden"  id="EMAIL_FROM_ADDRESS_OVERRIDE" name="EMAIL_FROM_ADDRESS_OVERRIDE" />


                        {/* Customer Identity */}
                        <Input type="hidden" value="Customer Account Holder Details:" id="Customer_Sub_Heading" name="Customer_Sub_Heading" />
                        <div className="customer-identity-container">
                            <h4>
                                Customer Account Holder Details:
                            </h4>
                            <FormGroup>
                                <Label>Customer's First Name<span className="mandatory">*</span></Label>
                                <Input name="Customers_First_Name" pattern="[a-zA-Z'’\s]+" type="text" id="Customers_First_Name" required />
                                <FormFeedback>Please enter first name</FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Customer's Surname<span className="mandatory">*</span></Label>
                                <Input name="Customers_Surname" pattern="[a-zA-Z'’\s]+" type="text" id="Customers_Surname" required />
                                <FormFeedback>Please enter a name</FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Account Number<span className="mandatory">*</span></Label>
                                <Input type="text" name="Customers_Account_Number" id="Customers_Account_Number" required />
                                <FormFeedback>Please enter a valid account number</FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Telephone Number<span className="mandatory">*</span></Label>
                                <Input type="tel" minLength="6" maxLength="10" pattern="^[0-9-+s()]*$" name="Customers_Tel_No" id="Customers_Tel_No" required />
                                <FormFeedback>Please enter a valid telephone number</FormFeedback>
                                <p>This number is shown on your bill and can begin with the prefix 01, 021. For customers with Standalone broadband this number will appear on the bill and begin with the pre-fix 8881, 8882, 8883, 087, 086, 085, 083</p>
                            </FormGroup>
                            <FormGroup>
                                <Label>Mobile Number</Label>
                                <Input type="tel" minLength="6" maxLength="10" pattern="^[0-9-+s()]*$" name="Customers_Mobile_No" id="Customers_Mobile_No" />

                            </FormGroup>
                            <FormGroup>
                                <Label>Email address</Label>
                                <Input type="email" name="Customers_Email_Address" id="Customers_Email_Address" onChange={this.emailScript} />
                            </FormGroup>
                            <FormGroup>
                                <Label>Customer's address line 1<span className="mandatory">*</span></Label>
                                <Input name="Customers_Address_One" type="text" id="Customers_Address_One" required />
                                <FormFeedback>Please enter address line 1 </FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Customer's address line 2</Label>
                                <Input name="Customers_Address_Two" type="text" id="Customers_Address_Two" />
                            </FormGroup>
                            <FormGroup>
                                <Label>Town/City<span className="mandatory">*</span></Label>
                                <Input name="Customers_Town_City" type="text" id="Customers_Town_City" required />
                                <FormFeedback>Please enter Town/City</FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>County<span className="mandatory">*</span></Label>
                                <Input type="select" name="Customers_County" id="Customers_County" required>
                                    <option value="">Select County</option>
                                    {CList != undefined &&
                                        (CList.map((name, i) => <option key={name.name}>{name.name}</option>))
                                    }
                                </Input>
                                <FormFeedback>Please enter county </FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Eircode<span className="mandatory">*</span></Label>
                                <Input name="Customers_Eircode" type="text" id="Customers_Eircode" minLength="7" maxLength="8" pattern="^[0-9a-zA-Z\s]*$" required />
                                <FormFeedback>Please enter Eircode </FormFeedback>
                            </FormGroup>

                            <p>Please be advised that if no contact information is supplied eir will complete this request but will be unable to give you confirmation that this request has been completed.</p>
                            {/* Authorised Details */}

                            <div>
                                <h4>
                                    Authorised User Details:
                            </h4>
                                <Input type="hidden" value="Authorised User Details:" id="Close_Sub_Heading" name="Close_Sub_Heading" />

                                <FormGroup>
                                    <Label>Authorised User First Name<span className="mandatory">*</span></Label>
                                    <Input name="Authorised_User_First_Name" pattern="[a-zA-Z'’\s]+" type="text" id="Authorised_User_First_Name" required />
                                    <FormFeedback>Please enter a name</FormFeedback>
                                </FormGroup>
                                <FormGroup>
                                    <Label>Authorised User Surname<span className="mandatory">*</span></Label>
                                    <Input name="Authorised_User_Surname" pattern="[a-zA-Z'’\s]+" type="text" id="Authorised_User_Surname" required />
                                    <FormFeedback>Please enter a name</FormFeedback>
                                </FormGroup>

                                <FormGroup>
                                    <Label>Authorised User Date of Birth<span className="mandatory">*</span></Label>
                                    <Input type="date" name="Authorised_User_DOB" id="Authorised_User_DOB" required />
                                    <FormFeedback>Please enter Date of Birth</FormFeedback>
                                </FormGroup>

                                <FormGroup>
                                    <Label>Authorised User Password<span className="mandatory">*</span></Label>
                                    <Input name="Authorised_User_Password" type="text" id="Authorised_User_Password" required />
                                    <p>We will use this password as additional verification for your authorised user, it will need to be something that they will need to remember.</p>
                                    <FormFeedback>Please enter Security Question</FormFeedback>
                                </FormGroup>


                            </div>



                            <div>
                                {/* Confirmation Details */}
                                <h4>
                                    Confirmation Details:
                                            </h4>

                                <FormGroup >
                                    <div >
                                        <div className="form-group">
                                            <div>
                                                <div className="custom-checkbox custom-control">
                                                    <Input required name="Declaration_Accepted" type="checkbox" id="Declaration_Accepted" className="custom-control-input" value="true" onClick={this.declarationAccept} />
                                                    <label className="custom-control-label" htmlFor="Declaration_Accepted">I confirm that I am the named account holder and that I grant eir the permission to set up the above name<br /> person as an authorised user for my account and that I fully understand the implications and responsibilities<br /> of doing so in accordance with eir’s Terms of Service and eir’s privacy policy.</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </FormGroup>
                                <FormGroup >
                                    <div >
                                        <div className="form-group">
                                            <div>
                                                <div className="custom-checkbox custom-control">
                                                    <Input required name="Age_Declaration_Accepted" type="checkbox" id="Age_Declaration_Accepted" className="custom-control-input" value="true" onClick={this.declarationAge} />
                                                    <label className="custom-control-label" htmlFor="Age_Declaration_Accepted">I confirm that the authorised user I have nominated is over the age of 18 </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </FormGroup>
                                <p className="justify-content">Your personal data will be processed in accordance with eir’s privacy policy.
                                            By clicking submit you confirm that you have read and understood this policy.</p>
                            </div>

                        </div>




                        <div className="d-flex justify-content-start">
                            <EirRecaptcha />
                        </div>

                        <div className="mt-4 d-flex justify-content-center">
                            <button type="submit" name="Submit" value="Submit" aria-label="Submit form" className="btn btn-primary" disabled={this.state.isAgeDeclaration || this.state.isDeclationAccept}
                                onClick={this.handleSubmit}>Submit</button>

                        </div>
                    </Form>
                )
                }

                {(this.state.response != null && this.state.response.result.status == 'success') && (
                    <div className="form-success align-items-center" dangerouslySetInnerHTML={this.renderContent(this.props.successMsg)}></div>
                    )}

                {(this.state.response != null && (this.state.response.result.status == 'failure' || this.state.response == false)) && (
                    <div className="form-error align-items-center">Form Submitted Failed</div>
                )}
            </div>
        )
    }
}

export default EirOnlineAuthorizedUserForm;
